import { findNodesToPrefetch } from '@atlaskit/node-data-provider/find-nodes-to-prefetch';
import { isJSONDocNode } from '@atlaskit/editor-json-transformer/main';
import type { JSONNode } from '@atlaskit/editor-json-transformer/types';

import { ConfluenceEditorCardProvider } from '@confluence/smartlinks';

import {
	NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH,
	NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT,
} from './nodeDataProvidersConstants.ts';

/**
 * Finds smart card nodes to prefetch from an already-parsed ADF document.
 */
export function findSmartCardNodesFromDoc(doc: unknown): JSONNode[] {
	if (!isJSONDocNode(doc)) {
		return [];
	}

	const cardProvider = new ConfluenceEditorCardProvider('custom');

	return findNodesToPrefetch(
		doc,
		[
			{
				provider: cardProvider,
				maxNodesToPrefetch: NODE_DATA_PROVIDERS_MAX_NODES_TO_PREFETCH.smartCard,
			},
		],
		NODE_DATA_PROVIDERS_MAX_NODES_TO_VISIT,
	)[0].nodes;
}
